/** Dialog for editing some VJT properties. */

import { Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, Input, InputLabel, ListItemText, MenuItem, OutlinedInput, Select } from "@material-ui/core";
import React, { ChangeEvent, useEffect, useState } from "react";
import { Alert, AlertTitle } from "@material-ui/lab";
import { Cancel, Delete, Save } from "@material-ui/icons";
import { objectToFormData } from "../../../../web-services/utils/object-to-form-data";
import { IFelhasznalokezeloRemoveProps } from "./props";

import "./felhasznalokezelo-confirm-dialog.scss";

// eslint-disable-next-line @typescript-eslint/naming-convention
export function FelhasznalokezeloRemoveDialog(props: IFelhasznalokezeloRemoveProps) {
    const [errorMsg, setErrorMsg] = useState<string | undefined>();
    const [errorCategoryMsg, setErrorCategoryMessage] = useState<string | undefined>();
    const [isRequestSending, setIsRequestSending] = useState<boolean | undefined>();
    const [selectedRoles, setSelectedRoles] = useState(props.user?.roles);

    const [id, setId] = useState(props.user?.id);
    const [username, setUsername] = useState(props.user?.username);
    const [teljesnev, setTeljesnev] = useState(props.user?.name);

    useEffect(() => {
        setId(props.user?.id);
        setUsername(props.user?.username);
        setTeljesnev(props.user?.name);
        setSelectedRoles(props.user?.roles);
        setErrorMsg(undefined);
    }, [props.user]);

    useEffect(() => {
        if (!isRequestSending) return;

        const fetchData = async () => {
            setErrorMsg(undefined);
            try {

                await props.httpClient.delete(
                    "user/delete",
                    "",
                    objectToFormData({
                        userId: id
                    }),
                    15000
                );
                setIsRequestSending(false);
                props.onSaveSuccess();
            }
            catch (err: any) {
                setIsRequestSending(false);
                console.log(err);

                if (err.message === "Nem várt hiba történt.") {
                    setErrorMsg("Kérjük, próbálja újra a mentést.");
                }
                else {
                    setErrorMsg(err.message);
                }
            }
        };

        fetchData().catch(console.error);
    }, [isRequestSending]);

    const renderAlert = (errorText: string | undefined, errorCategoryText: string | undefined) => (
        errorText
            ? (
                <Grid item xs={12}>
                    <Alert severity="error" className="vjt-edit-error">{errorCategoryText
                        ? <AlertTitle>{errorCategoryText}</AlertTitle> : undefined}{errorText}
                    </Alert>
                </Grid>
            )
            : undefined
    );

    const renderCircularProgress = () => (
        isRequestSending
            ? <Grid item xs={12}><div className="circular-progress-container"><CircularProgress size={24} /></div></Grid>
            : undefined
    );

    const renderDialogActions = () => {
        let buttons = [
            <Button
                key={8}
                startIcon={<Cancel />}
                variant="contained"
                color="secondary"
                onClick={props.onClose}
            >
                Mégsem
            </Button>
        ];
        buttons.push(
            <Button
                key={9}
                startIcon={<Delete />}
                variant="contained"
                disabled={isRequestSending}
                color="primary"
                onClick={() => setIsRequestSending(true)}
                autoFocus
            >
                Igen
            </Button>
        );

        return buttons;
    };


    return (
        <Dialog open={props.open || false}>
            <DialogTitle>{props.user?.name} Felhasználó törlése</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    Biztosan törölni szeretné a(z) {props.user?.username} nevű felhasználót?
                    {renderCircularProgress()}
                    {renderAlert(errorMsg, errorCategoryMsg)}
                </Grid>
            </DialogContent>
            <DialogActions>
                {renderDialogActions()}
            </DialogActions>
        </Dialog>
    );
}
